export default "a64e3c2815a87e48.svg"